export enum ReportHeaders {
  fullName = 'Name',
  courseName = 'Course Name',
  programYear = 'Program Year',
  status = 'Status',
  completedOn = 'Complete Date',
  districtName = 'District',
  schoolName = 'School',
  completionCount = 'Completion Total',
  incompleteCount = 'Incomplete Total',
}

export enum ReportProps {
  'Name' = 'fullName',
  'Email' = 'emailName',
  'Course Name' = 'courseName',
  'Program Year' = 'programYear',
  'Status' = 'status',
  'Complete Date' = 'completedOn',
  'District' = 'districtName',
  'School' = 'schoolName',
  'Completion Total' = 'completionCount',
  'Incomplete Total' = 'incompleteCount',
}
